import TENANT_ACTIONS from './tenent.action-types';


export const setTenant = (value: string) => ({
  type: TENANT_ACTIONS.SET_TENANT,
  payload: value,
});
